module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_14-1e98a99f1bbd6d297ba6fdbd80860cd2.png";